import React from 'react';
import { Link } from 'react-router-dom';
import styles from './DetaliiPlanCard.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faCalendarAlt, faCalendarCheck, faCalendar, faCreditCard, faFileInvoice, faCog } from '@fortawesome/free-solid-svg-icons';

const DetaliiPlanCard = ({ plan }) => {
  return (
    <div className={styles.detaliiPlanCard}>
      {/* 
      <h4 className={styles.title + ' ' + styles.hideOnMobile}>Detalii plan</h4>
      */}
      <div className={styles.planCardHeaderVertical}>
        <div className={styles.planBadgeVertical}>
          <FontAwesomeIcon icon={faCrown} className={styles.planIconVertical} />
          <span>{plan?.name || 'PERSONAL'}</span>
        </div>
        <div className={styles.planStatusVertical}>ACTIV</div>
      </div>
      <div className={styles.planDetailsVertical}>
        <div className={styles.planDetailRow}>
          <div className={styles.planDetailIconBig}><FontAwesomeIcon icon={faCalendarAlt} /></div>
          <div>
            <span className={styles.planDetailLabel}>DATA DE START</span>
            <span className={styles.planDetailValue}>{plan?.startDate || '01/12/2024'}</span>
          </div>
        </div>
        <div className={styles.planDetailRow}>
          <div className={styles.planDetailIconBig}><FontAwesomeIcon icon={faCalendarCheck} /></div>
          <div>
            <span className={styles.planDetailLabel}>VALABIL PANA LA</span>
            <span className={styles.planDetailValue}>{plan?.endDate || '01/12/2025'}</span>
          </div>
        </div>
        <div className={styles.planDetailRow}>
          <div className={styles.planDetailIconBig}><FontAwesomeIcon icon={faCalendar} /></div>
          <div>
            <span className={styles.planDetailLabel}>URMATOAREA FACTURARE</span>
            <span className={styles.planDetailValue}>{plan?.nextBilling || '02/12/2024'}</span>
          </div>
        </div>
        <div className={styles.planDetailRow}>
          <div className={styles.planDetailIconBig}><FontAwesomeIcon icon={faCreditCard} /></div>
          <div>
            <span className={styles.planDetailLabel}>METODA DE PLATA</span>
            <span className={styles.planDetailValue}>{plan?.paymentMethod || 'Card •••• 1234'}</span>
          </div>
        </div>
      </div>
      <div className={styles.planCardFooterVertical}>
        <button className={styles.btnDownloadInvoiceVertical}><FontAwesomeIcon icon={faFileInvoice} style={{ marginRight: 8 }} />Descarca factura</button>
        <button className={styles.btnManageSubscriptionVertical}><FontAwesomeIcon icon={faCog} style={{ marginRight: 8 }} />Gestioneaza abonament</button>
        <Link to="/planul-tau" style={{ textDecoration: 'none' }}>
          <button className={styles.btnManageSubscriptionVertical} style={{marginTop:8}}>
            Vezi detalii si gestioneaza
          </button>
        </Link>
      </div>
    </div>
  );
};

export default DetaliiPlanCard;
